import { useMemo, useEffect } from "react";
import { useLocation, Link, useNavigate } from "react-router-dom";
import {
  PRODUCTS,
  listByCategory,
  listBySubcategory,
} from "./products";

function useQuery() {
  const { search } = useLocation();
  return new URLSearchParams(search);
}

export default function CatalogPage() {
  const q = useQuery();
  const cat = q.get("cat");
  const sub = q.get("sub");
  const navigate = useNavigate();

  const items = useMemo(() => {
    if (cat && sub) return listBySubcategory(cat, sub);
    if (cat) return listByCategory(cat);
    return Object.values(PRODUCTS);
  }, [cat, sub]);

  // 🔁 Si hay exactamente 1 producto, vamos directo al módulo
  useEffect(() => {
    if (items.length === 1) {
      navigate(`/producto/${items[0].slug}`, { replace: true });
    }
  }, [items, navigate]);

  // Si ya redirigió, este render no se verá. Si no, muestra el grid.
  return (
    <div style={{ maxWidth: 1200, margin: "40px auto", padding: "0 16px" }}>
      <h1 style={{ marginBottom: 12 }}>
        Catálogo {cat ? `· ${cat}` : ""} {sub ? `· ${sub}` : ""}
      </h1>

      {!items.length ? (
        <p>No hay productos en esta categoría todavía.</p>
      ) : (
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fill, minmax(260px, 1fr))",
            gap: 16,
          }}
        >
          {items.map((p) => (
            <Link
              key={p.slug}
              to={`/producto/${p.slug}`}
              style={{
                display: "block",
                border: "1px solid rgba(0,0,0,0.08)",
                borderRadius: 12,
                overflow: "hidden",
                textDecoration: "none",
                color: "inherit",
                background: "#fff",
              }}
            >
              <div style={{ aspectRatio: "4/3", background: "#f6f7fb" }}>
                <img
                  src={Array.isArray(p.heroImage) ? p.heroImage[0] : p.heroImage}
                  alt={p.title}
                  loading="lazy"
                  style={{ width: "100%", height: "100%", objectFit: "cover" }}
                />
              </div>
              <div style={{ padding: 12 }}>
                <h3 style={{ margin: "0 0 6px" }}>{p.title}</h3>
                <small style={{ opacity: 0.7 }}>
                  {p.category} {p.subcategory ? `· ${p.subcategory}` : ""}
                </small>
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
